import { render } from "./VTBloccoStatistiche.vue?vue&type=template&id=688a82c9&scoped=true"
import script from "./VTBloccoStatistiche.vue?vue&type=script&lang=js"
export * from "./VTBloccoStatistiche.vue?vue&type=script&lang=js"

import "./VTBloccoStatistiche.vue?vue&type=style&index=0&id=688a82c9&scoped=true&lang=css"

import exportComponent from "C:\\Users\\adria\\OneDrive\\Escritorio\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-688a82c9"]])

export default __exports__